import { useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import FacebookIcon from 'mdi-react/FacebookIcon'
import { FacebookButton } from 'react-social'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import axios from 'axios'
import get from 'lodash/get'

import { useOnMount } from 'hooks'

import {
  rootStyle,
  contentStyle,
  countStyle
} from './FacebookShareButton.styles'

function FacebookShareButton({ url, appId, accessToken, ...props }) {
  const { t } = useTranslation()

  const [shareCount, setShareCount] = useState(0)

  useOnMount(async () => {
    const response = await axios
      .get(`https://graph.facebook.com/?id=${url}&fields=engagement&access_token=${accessToken}`)
      .catch(() => { })
    setShareCount(get(response, 'data.engagement.share_count', 0))
  })

  return (
    <Box
      component={FacebookButton}
      url={url}
      appId={appId}
      sx={rootStyle}
      {...props}
    >
      <Box component="span" sx={contentStyle}>
        <FacebookIcon size="2em" color="#4267b2" />
        <Box component="span" sx={countStyle}>
          {t('postFooter.fbShares', { count: shareCount })}
        </Box>
      </Box>
    </Box>
  )
}

const { string } = PropTypes

FacebookShareButton.propTypes = {
  url: string,
  appId: string,
  accessToken: string
}

export default FacebookShareButton
